import { api } from '@cashew/utils';
import { useEffect, useState } from 'react';
import type { TimelineType } from '../../../components/Timeline/timeline.types';

const parseDescription = (record: TimelineType): TimelineType => {
  const rec = {
    ...record,
    additionalInfo: {
      ...(record.additionalInfo || {}),
    },
  };
  if (!rec.additionalInfo) {
    rec.additionalInfo = {};
  }

  // Check if description exists before trying to match
  if (record.description) {
    const reg = /(\d+)/g;
    const arr = record.description.match(reg)?.filter((e) => e);
    if (arr && arr.length) {
      rec.additionalInfo.installments = arr.filter((e) => e.length === 16);
      // if description contains more than one number, then validate the last one is card number
      const lastNumber = arr[arr.length - 1];
      rec.additionalInfo.cardNumber =
        lastNumber.length < 16 ? lastNumber : undefined;
    }
  }

  return rec;
};

const processTimelineDescriptions = (data: any[]): TimelineType[] =>
  data.map(parseDescription);

const useOrderDetailsTimeline = (orderId: any) => {
  const [data, setData] = useState<TimelineType[]>();
  const [loading, setLoading] = useState(true);

  const getOrderDetailsTimeline = () => {
    api
      .get({
        endpoint: `orders/timeline/${orderId}`,
      })
      .then(async (resp) => {
        setData(processTimelineDescriptions(resp.data));
      })
      .catch((resp) => console.log(resp))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!orderId) {
      return;
    }

    getOrderDetailsTimeline();
  }, [orderId]);

  return { data, loading, getOrderDetailsTimeline };
};

export default useOrderDetailsTimeline;
